import { config } from '@uhg-abyss/web/tools/config';
import { storage } from '@uhg-abyss/web/tools/storage';
import { useEffect } from 'react';
import { useSessionStorage } from 'usehooks-ts';
import { useShallow } from 'zustand/react/shallow';

import { Constants } from '../../common/Constants';
import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { ProviderType } from '../../models/ProviderDetails';
import { usePcpEmailEligibilityStore } from '../../store/usePcpEmailStore';
import { PcpEmailEligibilityState } from '../../store/usePcpEmailStore/pcpEmailStore';
import { getPCPGetParams } from '../../utils/primaryCare.utils';
import { getCurrentMember, getLoggedInMember } from '../../utils/user.utils';
import { useCustomQuery } from '../useCustomQuery';
import { useFeatureFlag } from '../useFeatureFlag';
import GET_PRIMARY_CARE from '../usePrimaryCare/PrimaryCare.graphql';

const useReferralQuery = () => {
  // Needs to change once Referral API and GrapgQL is ready. For now, we are mocking the response to test the Referral Banner.
  const [queryResult, queryAction] = useCustomQuery(GET_PRIMARY_CARE, {
    url: config('GRAPHQL_API_URL'),
    accessor: 'referralBanner',
  });
  // Mocking Response for temporary purpose
  let status = '';
  if (queryResult?.data?.status === 'PENDING_APPROVAL') {
    status = 'PENDING_APPROVAL';
  } else if (queryResult?.data?.status === 'NO_REFERRAL') {
    status = 'NO_REFERRAL';
  } else if (queryResult?.data?.status === 'ACTIVE') {
    status = 'ACTIVE';
  } else if (queryResult?.data?.status === 'EXPIRING') {
    status = 'EXPIRING';
  } else if (queryResult?.data?.status === 'EXPIRED') {
    status = 'EXPIRED';
  } else if (queryResult?.data?.status === 'REJECTED') {
    status = 'REJECTED';
  } else if (queryResult?.data?.status === 'REJECTED') {
    status = 'REJECTED';
  } else {
    status = 'NO_REFERRAL';
  }

  // End Mocking Response for temporary purpose

  const parsedResult = {
    ...queryResult,
    status,
    providerId: '1234567',
  };

  return [parsedResult, queryAction];
};

export const useDisplayReferralBanner = ({ urlParams, providerType }) => {
  let refStatus = '';
  const { referralStatus } = urlParams;
  const currentMember = getCurrentMember();
  const [enableReferralSubmissionCTA] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_REFERRAL_SUBMISSION_CTA,
  ]);
  const { pcpEmailEligibilityData } = usePcpEmailEligibilityStore(
    useShallow((state: PcpEmailEligibilityState) => ({
      pcpEmailEligibilityData: state.pcpEmailEligibilityData,
    }))
  );
  const isReferralEligible = currentMember?.isReferralRequired;
  const isPractitioner = providerType === ProviderType.PRACTITIONER;
  const isPcpEmailEligible = pcpEmailEligibilityData?.hasPcpEmailEligibility;
  if (referralStatus) {
    if (referralStatus === 'Error') {
      // const referalSubmissionPayloadString = Buffer.from(
      //   submitRequestPayload,
      //   'base64'
      // ).toString();
      // const referalSubmissionPayloadJSON = JSON.parse(
      //   referalSubmissionPayloadString
      // );
      refStatus = 'ERROR';
    } else if (referralStatus === 'Success') {
      refStatus = 'PENDING_APPROVAL';
    }
    return { referralStatus: refStatus, isBannerVisible: true };
  }

  const [referralQueryResult, getReferralStatus] = useReferralQuery();

  const { IS_PREPROD_USER } = Constants.STORAGE_KEYS.SESSION;
  const loggedInMember = getLoggedInMember();
  const [memberId] = useSessionStorage(
    Constants.STORAGE_KEYS.SESSION.MEMBER_ID,
    0
  );

  useEffect(() => {
    if (
      enableReferralSubmissionCTA &&
      isReferralEligible &&
      isPractitioner &&
      isPcpEmailEligible
    ) {
      const variables = getPCPGetParams(
        storage.session.get(IS_PREPROD_USER),
        loggedInMember,
        memberId?.toString()
      );
      getReferralStatus({ variables } as any);
    }
  }, [
    enableReferralSubmissionCTA,
    isReferralEligible,
    isPractitioner,
    isPcpEmailEligible,
  ]);
  if (
    !enableReferralSubmissionCTA ||
    !isReferralEligible ||
    !isPractitioner ||
    !isPcpEmailEligible
  ) {
    return { referralStatus: null, isBannerVisible: false };
  }
  return { referralStatus: referralQueryResult.status, isBannerVisible: true };
};
